import type {DragDirection, Range, ResizeEndEvent, ResizeStartEvent, Span} from '@Libraries/timeline/types';
import type React from 'react';
import type {TimelineItemDurationContainerType} from '@Components/poster-editor/components/poster-editor-web-bottom-bar/components/duration-notification/duration-notification.types';
import {IconSize} from '@Components/icon-v2/icon.types';

export interface BaseTimelineItemProps {
  id: string;
  children: React.ReactNode;
  range: Range;
  onAutoScroll?: (increment: number, direction?: DragDirection) => void;
  onResizeMove?: (span: Span, direction: DragDirection) => void;
  onResizeStart?: (event: ResizeStartEvent) => void;
  onResizeEnd?: (event: ResizeEndEvent) => void;
  duration: number;
  durationItemType?: TimelineItemDurationContainerType;
  type?: TimelineItemType;
  isSelected?: boolean;
  onClick?(id: string): void;
  disabled?: boolean;
  disableDragOnly?: boolean;
  showAddButton?: boolean;
  addItemIconSize?: IconSize;
  onClickAddButton?(): void;
  isAddButtonDisabled?: boolean;
  minDuration?: number;
  maxDuration?: number;
  isUpdating?: boolean;
  /**
   * only sent for non design items
   */
  posterDuration?: number;
  isHidden?: boolean;
  isDesignItem?: boolean;
  isMultiPageEnabled?: boolean;
}

export enum TimelineItemType {
  Blue = 'blue',
  Purple = 'purple',
  Green = 'green',
}
